import * as React from 'react'
import { TaskTagDropdownConnected } from './TaskTagDropdownConnected'
import { Provider } from 'react-redux'
import { mockState, createMockStore, MOCK_TASK_A_ID } from 'mockState'

export const TaskTagDropdownExamples = () => {
  return (
    <div className="TaskTagDropdownExamples exampleContainer">
      <h1 className="exampleHeader">default</h1>

      <Provider store={createMockStore(mockState)}>
        <TaskTagDropdownConnected taskId={MOCK_TASK_A_ID} tagId={MOCK_TASK_A_ID} />
      </Provider>
    </div>
  )
}
